// components/BookList.js
import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { SearchContext } from '../App';

function BookList() {
  const { categoryId } = useParams();
  const [category, setCategory] = useState(null);
  const [books, setBooks] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { searchTerm, setSearchTerm } = useContext(SearchContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const categoryData = await api.getCategory(categoryId);
        setCategory(categoryData);
        
        const booksData = await api.getBooks(null, categoryId);
        setBooks(booksData);
        
        const subCategoriesData = await api.getSubCategories(categoryId);
        setSubCategories(subCategoriesData);
        
        setLoading(false);
      } catch (err) {
        setError('Failed to load data');
        setLoading(false);
      }
    };

    fetchData();
  }, [categoryId]);

  // Handle back button - go back to parent category or author
  const handleBack = () => {
    if (category && category.parentId) {
      navigate(`/category/${category.parentId}`);
    } else if (category && category.authorId) {
      navigate(`/author/${category.authorId}`);
    } else {
      navigate('/');
    }
  };

  // Filter subcategories and books based on search term
  const filteredSubCategories = subCategories.filter(subCategory =>
    subCategory.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const filteredBooks = books.filter(book =>
    book.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="loading">იტვირთება...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="book-list">
      <div className="top-bar">
        <button onClick={handleBack} className="back-button">
          ← დაბრუნება
        </button>
        
        <div className="search-container">
          <input
            type="text"
            placeholder="მოძებნე..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      </div>
      
      <h2>{category?.name}</h2>
      
      {filteredSubCategories.length > 0 && (
        <div className="section">
          <h3>Sub-Categories</h3>
          <div className="category-grid">
            {filteredSubCategories.map(subCategory => (
              <Link 
                to={`/category/${subCategory.id}`} 
                key={subCategory.id} 
                className="category-card"
              >
                <h4>{subCategory.name}</h4>
              </Link>
            ))}
          </div>
        </div>
      )}
      
      <div className="section">
        <h3>წიგნები</h3>
        <div className="book-grid">
          {filteredBooks.map(book => (
            <Link 
              to={`/book/${book.id}`} 
              key={book.id} 
              className="book-card"
            >
              <div className="book-image">
                <img src={`/images/books/${book.id}.jpg`} alt={book.name} onError={(e) => {e.target.src = '/images/default-book.jpg'}} />
              </div>
              <h4>{book.name}</h4>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BookList;